// extracted by mini-css-extract-plugin
export default {"form__opacity-anim":"AnimatedForm_form__opacity-anim__dWG3Y"};